import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b6fd7df"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user-infos",
  class: "description-list"
}
const _hoisted_2 = {
  key: 1,
  class: "info-box success-message"
}
const _hoisted_3 = {
  key: 4,
  class: "email-form form-box"
}
const _hoisted_4 = {
  class: "form-items",
  for: "email"
}
const _hoisted_5 = {
  class: "form-items",
  for: "email"
}
const _hoisted_6 = { class: "form-buttons" }
const _hoisted_7 = {
  class: "confirm",
  type: "submit"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { class: "user-bio" }
const _hoisted_11 = {
  key: 0,
  class: "profile-buttons"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "profile-buttons"
}

import { format } from 'date-fns'
  import {
    ComputedRef,
    Ref,
    computed,
    ref,
    toRefs,
    withDefaults,
    watch,
    onUnmounted,
  } from 'vue'

  import { AUTH_USER_STORE, ROOT_STORE, USERS_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { IAuthUserProfile, IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
    fromAdmin?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    fromAdmin: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: IUserProfile, fromAdmin: boolean }

  

  const store = useStore()

  const { user, fromAdmin } = toRefs(props)
  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const registrationDate = computed(() =>
    props.user.created_at
      ? format(new Date(props.user.created_at), 'dd/MM/yyyy HH:mm')
      : ''
  )
  const birthDate = computed(() =>
    props.user.birth_date
      ? format(new Date(props.user.birth_date), 'dd/MM/yyyy')
      : ''
  )
  const isSuccess = computed(
    () => store.getters[USERS_STORE.GETTERS.USERS_IS_SUCCESS]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  let displayModal: Ref<string> = ref('')
  const formErrors = ref(false)
  const displayUserEmailForm: Ref<boolean> = ref(false)
  const newUserEmail: Ref<string> = ref('')
  const currentAction: Ref<string> = ref('')

  function updateDisplayModal(value: string) {
    displayModal.value = value
    if (value !== '') {
      store.commit(USERS_STORE.MUTATIONS.UPDATE_IS_SUCCESS, false)
    }
  }
  function deleteUserAccount(username: string) {
    store.dispatch(USERS_STORE.ACTIONS.DELETE_USER_ACCOUNT, { username })
  }
  function resetUserPassword(username: string) {
    currentAction.value = 'password-reset'
    store.dispatch(USERS_STORE.ACTIONS.UPDATE_USER, {
      username,
      resetPassword: true,
    })
  }
  function confirmUserAccount(username: string) {
    store.dispatch(USERS_STORE.ACTIONS.UPDATE_USER, {
      username,
      activate: true,
    })
  }
  function displayEmailForm() {
    resetErrorsAndSuccess()
    newUserEmail.value = user.value.email_to_confirm
      ? user.value.email_to_confirm
      : ''
    displayUserEmailForm.value = true
    currentAction.value = 'email-update'
  }
  function hideEmailForm() {
    newUserEmail.value = ''
    displayUserEmailForm.value = false
  }
  function updateUserEmail(username: string) {
    store.dispatch(USERS_STORE.ACTIONS.UPDATE_USER, {
      username,
      new_email: newUserEmail.value,
    })
  }
  function resetErrorsAndSuccess() {
    store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
    store.commit(USERS_STORE.MUTATIONS.UPDATE_IS_SUCCESS, false)
    currentAction.value = ''
  }

  onUnmounted(() => resetErrorsAndSuccess())

  watch(
    () => isSuccess.value,
    (newIsSuccess) => {
      if (newIsSuccess) {
        updateDisplayModal('')
        hideEmailForm()
      }
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_AlertMessage = _resolveComponent("AlertMessage")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(displayModal))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.$t('common.CONFIRMATION'),
          message: 
        _unref(displayModal) === 'delete'
          ? 'admin.CONFIRM_USER_ACCOUNT_DELETION'
          : 'admin.CONFIRM_USER_PASSWORD_RESET'
      ,
          strongMessage: _unref(user).username,
          onConfirmAction: _cache[0] || (_cache[0] = ($event: any) => (
        _unref(displayModal) === 'delete'
          ? deleteUserAccount(_unref(user).username)
          : resetUserPassword(_unref(user).username)
      )),
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayModal('')))
        }, null, 8, ["title", "message", "strongMessage"]))
      : _createCommentVNode("", true),
    (_unref(isSuccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(
          `admin.${
            currentAction.value === 'password-reset'
              ? 'PASSWORD_RESET'
              : 'USER_EMAIL_UPDATE'
          }_SUCCESSFUL`
        )), 1))
      : _createCommentVNode("", true),
    (!_unref(user).is_active)
      ? (_openBlock(), _createBlock(_component_AlertMessage, {
          key: 2,
          message: "user.THIS_USER_ACCOUNT_IS_INACTIVE"
        }))
      : _createCommentVNode("", true),
    (_unref(errorMessages))
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 3,
          message: _unref(errorMessages)
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (displayUserEmailForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("form", {
            class: _normalizeClass({ errors: formErrors.value }),
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (updateUserEmail(_unref(user).username)), ["prevent"]))
          }, [
            _createElementVNode("label", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('admin.CURRENT_EMAIL')) + " ", 1),
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).email) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _unref(user).email]
              ])
            ]),
            _createElementVNode("label", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t('admin.NEW_EMAIL')) + "* ", 1),
              _withDirectives(_createElementVNode("input", {
                id: "new-email",
                type: "email",
                required: "",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newUserEmail).value = $event))
              }, null, 512), [
                [_vModelText, newUserEmail.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 1),
              _createElementVNode("button", {
                class: "cancel",
                onClick: _withModifiers(hideEmailForm, ["prevent"])
              }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 9, _hoisted_8)
            ])
          ], 34)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.REGISTRATION_DATE')) + ":", 1),
            _createElementVNode("dd", null, _toDisplayString(_unref(registrationDate)), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.FIRST_NAME')) + ":", 1),
            _createElementVNode("dd", null, _toDisplayString(_unref(user).first_name), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.LAST_NAME')) + ":", 1),
            _createElementVNode("dd", null, _toDisplayString(_unref(user).last_name), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.BIRTH_DATE')) + ":", 1),
            _createElementVNode("dd", null, _toDisplayString(_unref(birthDate)), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.LOCATION')) + ":", 1),
            _createElementVNode("dd", null, _toDisplayString(_unref(user).location), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.BIO')) + ":", 1),
            _createElementVNode("dd", _hoisted_10, _toDisplayString(_unref(user).bio), 1)
          ]),
          (_unref(fromAdmin))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_unref(authUser).username !== _unref(user).username)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "danger",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (updateDisplayModal('delete')), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('admin.DELETE_USER')), 1))
                  : _createCommentVNode("", true),
                (!_unref(user).is_active)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (confirmUserAccount(_unref(user).username)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('admin.ACTIVATE_USER_ACCOUNT')), 1))
                  : _createCommentVNode("", true),
                (_unref(authUser).username !== _unref(user).username)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _withModifiers(displayEmailForm, ["prevent"])
                    }, _toDisplayString(_ctx.$t('admin.UPDATE_USER_EMAIL')), 9, _hoisted_12))
                  : _createCommentVNode("", true),
                (
            _unref(authUser).username !== _unref(user).username &&
            _unref(appConfig).is_email_sending_enabled
          )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (updateDisplayModal('reset')), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('admin.RESET_USER_PASSWORD')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.go(-1)))
                }, _toDisplayString(_ctx.$t('buttons.BACK')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/profile/edit')))
                }, _toDisplayString(_ctx.$t('user.PROFILE.EDIT')), 1),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/')))
                }, _toDisplayString(_ctx.$t('common.HOME')), 1)
              ]))
        ]))
  ]))
}
}

})